<template>
    <div class="takequiz">
    <h2> The Title of the show or movie or whatever goes here </h2>
    </div>
</template>
<script>
export default {
  name: 'QuizTitle',
  props: {
    msg: String
  }
}
</script>

<style>

</style>
